import { isSupportedRepub } from '@cx-web/repub-config';
import { getRepubMetaFromRepub } from '@cx-web/utils';
import { getCanonicalURL } from '@cx-web/utils/getCanonicalURL';
import type { MetaFunction } from '@remix-run/node';

import { type Repub } from '@cx-modules/constants';

import { type loader } from './landing-page-single-tier/loader.server';

export const meta: MetaFunction<never, { [routeId: string]: typeof loader }> = ({ location, matches }) => {
  const data = matches.find(match => /plus$/.test(match.id))?.data;

  const repub = data?.repub as Repub;

  if (!isSupportedRepub(repub)) {
    throw new Error('Repub data is missing from layout match');
  }

  const { repubIs } = getRepubMetaFromRepub(repub);

  const brandName = repubIs.WS ? 'WhoScored Plus' : 'Oddschecker Plus';

  const href = data?.url
    ? getCanonicalURL(data.url.toString(), location.pathname)
    : getCanonicalURL('', location.pathname);
  return [
    { title: brandName },
    { name: 'description', content: brandName },
    {
      tagName: 'link',
      rel: 'canonical',
      href,
    },
  ];
};
